export default "__VITE_ASSET__BgJa8xwh__"